import { observer } from "mobx-react";
import * as React from "react";
import { AAA_HOMEPAGE, DAL_HOMEPAGE } from "../../config";
import { t } from "../../i18n/util";
import { THEME } from "../../theme/ThemeStore";
import { useMobileMediaQuery } from "../hooks/useMobileMediaQuery";
import { HrBotButton, SectionHeaderSmall } from "../ui/Primitives";

type Props = {
    header: string | null;
};

export const Success = observer(({ header }: Props) => {
    const isMobile = useMobileMediaQuery();

    const handleBack = () => {
        const target = THEME.THEME_NAME === "dal" ? DAL_HOMEPAGE : AAA_HOMEPAGE;

        window.onbeforeunload = null;
        window.open(target, "_self");
    };
    return (
        <div>
            {!isMobile && <h2 style={{ marginBottom: 76 }}>{header}</h2>}
            <h3
                style={{
                    marginBottom: 30
                }}
            >
                {t("screen.success.title")}
            </h3>
            <p
                style={{
                    wordWrap: "break-word",
                    marginBottom: 70,
                    maxWidth: 400
                }}
            >
                {t("screen.success.info")}
            </p>
            <SectionHeaderSmall
                label={THEME.THEME_NAME === "dal" ? t("screen.success.dal.company") : t("screen.success.aaa.company")}
                style={{
                    marginBottom: 10
                }}
            />
            <p>
                {THEME.THEME_NAME === "dal"
                    ? t("screen.success.dal.address.street")
                    : t("screen.success.aaa.address.street")}
            </p>
            <p>
                {THEME.THEME_NAME === "dal" ? t("screen.success.dal.address.zip") : t("screen.success.aaa.address.zip")}
            </p>
            <p>{THEME.THEME_NAME === "dal" ? t("screen.success.dal.tel") : t("screen.success.aaa.tel")}</p>
            <p>{THEME.THEME_NAME === "dal" ? t("screen.success.dal.email") : t("screen.success.aaa.email")}</p>
            <HrBotButton
                onClick={handleBack}
                label={THEME.THEME_NAME === "dal" ? t("screen.success.dal.back") : t("screen.success.aaa.back")}
                style={{ marginTop: 60 }}
            />
        </div>
    );
});
